import React from 'react';
import ImageHelp from './imageHelp';
import vehicleImage from '../../../../assets/images/help/vehicle_help.png';
import '../../utils/style.css';
import { Card } from 'reactstrap';
import { FaHandPointDown } from 'react-icons/fa';

const VehicleHelp = () => {
    return (
        <div className="helpContainer">
            <h2 className="helpTitle">Gestion des Véhicules</h2>
            <p className="helpDescription">
                Bienvenue dans la section dédiée à la gestion de votre flotte de véhicules. 
                Ici, vous pouvez visualiser, ajouter, modifier et supprimer des véhicules en toute simplicité.
                Découvrez les fonctionnalités ci-dessous pour une gestion optimale de vos ressources :
            </p>
            
            <div className="helpFeaturesAndImageContainer">
                <div className="helpTextContainer">
                    <ul className="helpFeaturesList">
                        <li><strong>Visualisation de la flotte :</strong> Accédez à la liste complète de tous vos véhicules pour en suivre l'état et les informations clés.</li>
                        <li><strong>Ajout de nouveaux véhicules :</strong> Enregistrez facilement de nouveaux véhicules dans votre flotte.</li>
                        <li><strong>Modification de véhicule :</strong> Mettez à jour les détails de vos véhicules existants, comme leur affectation ou leur statut.</li>
                        <li><strong>Affectation à un chauffeur :</strong> Assignez chaque véhicule à un chauffeur spécifique pour une gestion fluide.</li>
                        <li><strong>Suppression de véhicules :</strong> Supprimez les véhicules obsolètes ou inutilisés de votre base de données.</li>
                        <li><strong>Historique des véhicules :</strong> Accédez à l'historique complet des chauffeurs précédemment affectés à chaque véhicule pour une meilleure gestion des affectations et un suivi optimal de la flotte.</li>
                    </ul>
                </div>
                <div className="helpImageContainer">
                    <p className="helpBase">
                        Cliquez sur l'image pour voir de près.  <FaHandPointDown className="animated-icon" />
                    </p>
                    <Card className='card-animate'>
                        <ImageHelp fileSource={vehicleImage} width="100%" />
                    </Card>
                </div>
            </div>
            <p className="helpBase">
                Pour plus de détails sur chaque action ou l'application en entier, contactez le support technique de Systalink.
            </p>
        </div>
    );
};

export default VehicleHelp;
